export const DEFAULT_STORE_PRIMARY = '#2D6CDF';
export const DEFAULT_STORE_PRIMARY_HOVER = '#1A5BC4';
export const DEFAULT_STORE_ACCENT = '#10b981';

export function darkenColor(hex, amount = 0.15) {
  const raw = (hex || DEFAULT_STORE_PRIMARY).replace('#', '');
  const normalized = raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw;
  const num = parseInt(normalized, 16);
  if (Number.isNaN(num)) return DEFAULT_STORE_PRIMARY_HOVER;

  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;
  r = Math.max(0, Math.floor(r * (1 - amount)));
  g = Math.max(0, Math.floor(g * (1 - amount)));
  b = Math.max(0, Math.floor(b * (1 - amount)));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export function resolveStoreTheme(storeOrBranding) {
  const store = storeOrBranding?.tenant || storeOrBranding;
  const branding = storeOrBranding?.branding || store?.branding;
  const primary = store?.primary_color || DEFAULT_STORE_PRIMARY;
  const accent = store?.accent_color || DEFAULT_STORE_ACCENT;

  return {
    primary,
    primaryHover: darkenColor(primary),
    accent,
    logoUrl: branding?.logo_url || store?.logo_url || '',
    brandName: branding?.brand_name || store?.name || store?.business_name || 'Toko',
    subdomain: store?.subdomain || '',
  };
}

export function applyStoreThemeVars(theme, target = document.documentElement) {
  if (!target || !theme) return;
  target.style.setProperty('--store-primary', theme.primary || DEFAULT_STORE_PRIMARY);
  target.style.setProperty('--store-primary-hover', theme.primaryHover || DEFAULT_STORE_PRIMARY_HOVER);
  target.style.setProperty('--store-accent', theme.accent || DEFAULT_STORE_ACCENT);
}
